import { upload } from '@ublend-npm/multipart-uploader';
import { FILE_UPLOADER_V2 } from '../constants/endpoints';
import normalizeImageOrientation from './normalizeImageOrientation';

const uploadAvatar = async ({ file }): Promise<string> => {
  const normalizedFile = await normalizeImageOrientation(file);
  const response = await upload({
    file: normalizedFile,
    uploadUrl: FILE_UPLOADER_V2(),
    storage: 'avatar',
  });
  return response.fileUrl;
};

export default uploadAvatar;
